export default {
  id: 'MediaCenterInputField',
  code: 'CN',
  text: {
    'Add Image': '选择图片',
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/Fields/MediaCenter/locale.js